// ============================================================
// CLIENTES EXTRA — Ahora persistente en el servidor
// Reemplaza localStorage('dtf_clientes_extra')
// ============================================================

import type { ApiResponse } from '../types';

const API = '/api';
let cache: Record<string, Record<string, unknown>> | null = null;

function getHeaders(): Record<string, string> {
  const stored = localStorage.getItem('auth-storage');
  let token = '';
  if (stored) {
    try { token = JSON.parse(stored)?.state?.token || ''; } catch { /* */ }
  }
  return { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
}

// Cargar todos los extras del servidor (con caché)
export async function loadAllExtras(force = false): Promise<Record<string, Record<string, unknown>>> {
  if (cache && !force) return cache;
  try {
    const res = await fetch(`${API}/clientes-extra`, { headers: getHeaders() });
    const json = await res.json() as ApiResponse<Record<string, Record<string, unknown>>>;
    cache = json.data || {};

    // Mirror a localStorage (fuente de verdad = servidor, mirror es solo para
    // lecturas síncronas de las páginas). Siempre sobreescribe con lo del servidor.
    try { localStorage.setItem('dtf_clientes_extra', JSON.stringify(cache)); } catch { /* */ }
    return cache;
  } catch {
    return {};
  }
}

// Obtener datos de un cliente (desde caché)
export function getExtra(telefono: string): Record<string, unknown> | null {
  if (!cache) return null;
  return cache[telefono] || null;
}

// Obtener de forma síncrona (para compatibilidad)
export function getExtraSync(telefono: string): Record<string, unknown> | null {
  if (!cache) {
    // Fallback a localStorage durante la migración
    try {
      const local = localStorage.getItem('dtf_clientes_extra');
      if (local) {
        const data = JSON.parse(local);
        return data[telefono] || null;
      }
    } catch { /* */ }
    return null;
  }
  return cache[telefono] || null;
}

// Guardar datos de un cliente (servidor + localStorage mirror)
export async function setExtra(telefono: string, data: Record<string, unknown>): Promise<void> {
  try {
    await fetch(`${API}/clientes-extra/${telefono}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    if (cache) {
      if (!cache[telefono]) cache[telefono] = {};
      Object.assign(cache[telefono], data);
    }
    // Mirror a localStorage para compatibilidad
    try {
      const local = JSON.parse(localStorage.getItem('dtf_clientes_extra') || '{}');
      if (!local[telefono]) local[telefono] = {};
      Object.assign(local[telefono], data);
      localStorage.setItem('dtf_clientes_extra', JSON.stringify(local));
    } catch { /* */ }
  } catch { /* */ }
}

// Invalidar caché
export function clearCache() {
  cache = null;
}
